// source: UserAssetBalancePb.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.UserAssetBalancePb', null, global)
goog.exportSymbol('proto.UserAssetBalancePb.UserWallet', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UserAssetBalancePb = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UserAssetBalancePb.repeatedFields_, null)
}
goog.inherits(proto.UserAssetBalancePb, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UserAssetBalancePb.displayName = 'proto.UserAssetBalancePb'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UserAssetBalancePb.UserWallet = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.UserAssetBalancePb.UserWallet, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UserAssetBalancePb.UserWallet.displayName = 'proto.UserAssetBalancePb.UserWallet'
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UserAssetBalancePb.repeatedFields_ = [5]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.UserAssetBalancePb.prototype.toObject = function (opt_includeInstance) {
    return proto.UserAssetBalancePb.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.UserAssetBalancePb} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.UserAssetBalancePb.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        usdtAssets: jspb.Message.getFieldWithDefault(msg, 1, ''),
        usdtAvailableAssets: jspb.Message.getFieldWithDefault(msg, 2, ''),
        totalAssets: jspb.Message.getFieldWithDefault(msg, 3, ''),
        btcAssets: jspb.Message.getFieldWithDefault(msg, 4, ''),
        userWalletList: jspb.Message.toObjectList(
          msg.getUserwalletlistList(),
          proto.UserAssetBalancePb.UserWallet.toObject,
          includeInstance
        ),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UserAssetBalancePb}
 */
proto.UserAssetBalancePb.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.UserAssetBalancePb()
  return proto.UserAssetBalancePb.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UserAssetBalancePb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UserAssetBalancePb}
 */
proto.UserAssetBalancePb.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setUsdtassets(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setUsdtavailableassets(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalassets(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setBtcassets(value)
        break
      case 5:
        var value = new proto.UserAssetBalancePb.UserWallet()
        reader.readMessage(value, proto.UserAssetBalancePb.UserWallet.deserializeBinaryFromReader)
        msg.addUserwalletlist(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UserAssetBalancePb.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.UserAssetBalancePb.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UserAssetBalancePb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserAssetBalancePb.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getUsdtassets()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getUsdtavailableassets()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getTotalassets()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getBtcassets()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getUserwalletlistList()
  if (f.length > 0) {
    writer.writeRepeatedMessage(5, f, proto.UserAssetBalancePb.UserWallet.serializeBinaryToWriter)
  }
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.UserAssetBalancePb.UserWallet.prototype.toObject = function (opt_includeInstance) {
    return proto.UserAssetBalancePb.UserWallet.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.UserAssetBalancePb.UserWallet} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.UserAssetBalancePb.UserWallet.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        coinid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        totalAmount: jspb.Message.getFieldWithDefault(msg, 2, ''),
        total: jspb.Message.getFieldWithDefault(msg, 3, ''),
        frozen: jspb.Message.getFieldWithDefault(msg, 4, ''),
        borrow: jspb.Message.getFieldWithDefault(msg, 5, ''),
        coinname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        shortName: jspb.Message.getFieldWithDefault(msg, 7, ''),
        withdraw: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
        recharge: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
        usdtprice: jspb.Message.getFieldWithDefault(msg, 10, ''),
        price: jspb.Message.getFieldWithDefault(msg, 11, ''),
        sortid: jspb.Message.getFieldWithDefault(msg, 12, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UserAssetBalancePb.UserWallet}
 */
proto.UserAssetBalancePb.UserWallet.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.UserAssetBalancePb.UserWallet()
  return proto.UserAssetBalancePb.UserWallet.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UserAssetBalancePb.UserWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UserAssetBalancePb.UserWallet}
 */
proto.UserAssetBalancePb.UserWallet.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setCoinid(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalamount(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotal(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setFrozen(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setBorrow(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setCoinname(value)
        break
      case 7:
        var value = /** @type {string} */ (reader.readString())
        msg.setShortname(value)
        break
      case 8:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setWithdraw(value)
        break
      case 9:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setRecharge(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setUsdtprice(value)
        break
      case 11:
        var value = /** @type {string} */ (reader.readString())
        msg.setPrice(value)
        break
      case 12:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSortid(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UserAssetBalancePb.UserWallet.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.UserAssetBalancePb.UserWallet.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UserAssetBalancePb.UserWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserAssetBalancePb.UserWallet.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getCoinid()
  if (f !== 0) {
    writer.writeInt32(1, f)
  }
  f = message.getTotalamount()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getTotal()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getFrozen()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getBorrow()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getCoinname()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getShortname()
  if (f.length > 0) {
    writer.writeString(7, f)
  }
  f = message.getWithdraw()
  if (f) {
    writer.writeBool(8, f)
  }
  f = message.getRecharge()
  if (f) {
    writer.writeBool(9, f)
  }
  f = message.getUsdtprice()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
  f = message.getPrice()
  if (f.length > 0) {
    writer.writeString(11, f)
  }
  f = message.getSortid()
  if (f !== 0) {
    writer.writeInt32(12, f)
  }
}

/**
 * optional int32 coinId = 1;
 * @return {number}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getCoinid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setCoinid = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional string totalAmount = 2;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getTotalamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setTotalamount = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string total = 3;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getTotal = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setTotal = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string frozen = 4;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getFrozen = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setFrozen = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string borrow = 5;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getBorrow = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setBorrow = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string coinName = 6;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getCoinname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setCoinname = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional string shortName = 7;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getShortname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setShortname = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value)
}

/**
 * optional bool withdraw = 8;
 * @return {boolean}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getWithdraw = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false))
}

/**
 * @param {boolean} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setWithdraw = function (value) {
  return jspb.Message.setProto3BooleanField(this, 8, value)
}

/**
 * optional bool recharge = 9;
 * @return {boolean}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getRecharge = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false))
}

/**
 * @param {boolean} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setRecharge = function (value) {
  return jspb.Message.setProto3BooleanField(this, 9, value)
}

/**
 * optional string usdtPrice = 10;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getUsdtprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setUsdtprice = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional string price = 11;
 * @return {string}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value)
}

/**
 * optional int32 sortId = 12;
 * @return {number}
 */
proto.UserAssetBalancePb.UserWallet.prototype.getSortid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0))
}

/**
 * @param {number} value
 * @return {!proto.UserAssetBalancePb.UserWallet} returns this
 */
proto.UserAssetBalancePb.UserWallet.prototype.setSortid = function (value) {
  return jspb.Message.setProto3IntField(this, 12, value)
}

/**
 * optional string usdtAssets = 1;
 * @return {string}
 */
proto.UserAssetBalancePb.prototype.getUsdtassets = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.setUsdtassets = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string usdtAvailableAssets = 2;
 * @return {string}
 */
proto.UserAssetBalancePb.prototype.getUsdtavailableassets = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.setUsdtavailableassets = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string totalAssets = 3;
 * @return {string}
 */
proto.UserAssetBalancePb.prototype.getTotalassets = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.setTotalassets = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string btcAssets = 4;
 * @return {string}
 */
proto.UserAssetBalancePb.prototype.getBtcassets = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.setBtcassets = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * repeated UserWallet userWalletList = 5;
 * @return {!Array<!proto.UserAssetBalancePb.UserWallet>}
 */
proto.UserAssetBalancePb.prototype.getUserwalletlistList = function () {
  return /** @type{!Array<!proto.UserAssetBalancePb.UserWallet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UserAssetBalancePb.UserWallet, 5)
  )
}

/**
 * @param {!Array<!proto.UserAssetBalancePb.UserWallet>} value
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.setUserwalletlistList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value)
}

/**
 * @param {!proto.UserAssetBalancePb.UserWallet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UserAssetBalancePb.UserWallet}
 */
proto.UserAssetBalancePb.prototype.addUserwalletlist = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.UserAssetBalancePb.UserWallet, opt_index)
}

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.UserAssetBalancePb} returns this
 */
proto.UserAssetBalancePb.prototype.clearUserwalletlistList = function () {
  return this.setUserwalletlistList([])
}

goog.object.extend(exports, proto)
